import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="w-full bg-navy-light py-20 px-4 border-y border-white/5" data-id="element-64">
      <div className="max-w-4xl mx-auto" data-id="element-65">
        <div className="bg-navy border border-gold/30 p-8 md:p-12 rounded-2xl flex flex-col md:flex-row items-center gap-8" data-id="element-66">
          <div className="flex-shrink-0" data-id="element-67">
            <ShieldCheck className="w-24 h-24 text-gold" data-id="element-68" />
          </div>
          <div className="text-center md:text-left" data-id="element-69">
            <h2 className="text-2xl md:text-3xl font-headline font-bold text-white uppercase mb-4" data-id="element-70">
              Iron-Clad Guarantee — 7 Days
            </h2>
            <p className="text-gray-300 leading-relaxed mb-4" data-id="element-71">
              If after reading this manual you feel it doesn't give you an
              unfair advantage over other parents, or if you feel it isn't the
              clearest path you've seen for your kid's future, write to me
              within the first{' '}
              <span className="text-gold font-bold" data-id="element-72">7 days</span> and I will
              refund every penny.
            </p>
            <p className="text-white font-bold uppercase tracking-wider" data-id="element-73">
              No questions asked. Zero risk.
            </p>
          </div>
        </div>
      </div>
    </section>;
}